<div [ngClass]="menuClass">
  <div
    *ngFor="let menu of menus"
    class="ad-menu-item"
    (click)="clickMenu($event, menu)"
  >
    <div class="ad-menu-item-logo">
      <div [class]="menu.iconClass">
        <div
          *ngIf="wrapper.menuIconTemplate"
          class="ad-menu-icon-template-wrapper"
        >
          <ng-container
            *ngTemplateOutlet="
              wrapper.menuIconTemplate;
              context: { $implicit: menu }
            "
          ></ng-container>
        </div>
      </div>
    </div>
    <div
      class="ad-menu-item-text"
      [ngClass]="{ 'ad-menu-item-text_selected': selectedMenu === menu }"
    >
      {{ menu.text }}
    </div>
  </div>
  <div *ngIf="wrapper.menusTemplate" class="menusTemplate">
    <ng-container *ngTemplateOutlet="wrapper.menusTemplate"></ng-container>
  </div>
</div>
